<template>
  <div class="mb-5">
    <h4 class="text-center text-h4 mb-3">{{ title }}</h4>

    <p class="text-center">
      Total de pacientes:
      <v-chip
        label
        color="blue lighten-4"
        class="font-work-sans font-weight-bold primary--text"
        >{{ items.length }}
      </v-chip>
    </p>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      disable-sort
      hide-default-footer
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.patient="{ item }">
        {{ patientName(item) }}
      </template>
      <template v-slot:item.priority="{ item }">
        {{ priorityLabel(item.priorityId) }}
      </template>
      <template v-slot:item.time="{ item }">
        {{ formatTime(item) }}
      </template>
      <template v-slot:item.isUnderage="{ item }">
        {{ yesNo(item.isUnderage) }}
      </template>
      <template v-slot:item.severalPatients="{ item }">
        {{ yesNo(item.severalPatients) }}
      </template>
      <template v-slot:item.reassignationCount="{ item }">
        {{ item.reassignationCount || 0 }}
      </template>
      <template v-slot:item.isHomeSampling="{ item }">
        {{ yesNo(item.isHomeSampling) }}
      </template>
      <template v-slot:item.station="{ item }">
        {{ item[stationField] || '—' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
const PRIORITY_VALUES = {
  1: 'Directo a estación',
  2: 'Prioridad',
  4: 'Particular',
  5: 'Domicilio',
  7: 'Prioridad absoluta',
}

export default {
  name: 'QueueTable',
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    showCalled: {
      type: Boolean,
      default: false,
    },
    timeField: {
      type: String,
      default: 'createdAt',
    },
    stationField: {
      type: String,
      default: 'cashDeskId',
    },
  },
  computed: {
    headers() {
      const headers = [
        { text: 'Número', align: 'center', value: 'number' },
        { text: 'Paciente', align: 'center', value: 'patient' },
        { text: 'Prioridad', align: 'center', value: 'priority' },
        { text: 'Tiempo', align: 'center', value: 'time' },
        { text: 'Menor de edad', align: 'center', value: 'isUnderage' },
        { text: 'Varios pacientes', align: 'center', value: 'severalPatients' },
        {
          text: 'Reasignaciones',
          align: 'center',
          value: 'reassignationCount',
        },
        { text: 'Domicilio', align: 'center', value: 'isHomeSampling' },
      ]

      if (this.showCalled) {
        headers.push({
          text: 'Estación',
          align: 'center',
          value: 'station',
        })
      }

      return headers.map((header, index) => ({
        ...header,
        class: [
          'primary',
          'white--text',
          'font-weight-bold',
          'text-subtitle-2',
          index === 0 ? 'rounded-tl-lg' : '',
          index === headers.length - 1 ? 'rounded-tr-lg' : '',
        ]
          .filter(Boolean)
          .join(' '),
      }))
    },
  },
  methods: {
    patientName(item) {
      return `${item.firstName || ''} ${item.lastName || ''}`.trim()
    },
    priorityLabel(priorityId) {
      return PRIORITY_VALUES[priorityId] || priorityId || '—'
    },
    yesNo(value) {
      return value == null ? '—' : value ? 'Sí' : 'No'
    },
    formatTime(item) {
      const value = item[this.timeField]
      const date = value ? new Date(value) : new Date()

      if (this.timeField === 'updatedAt') {
        return date.toLocaleString('es-VE', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })
      }

      return date.toLocaleString('es-VE', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      })
    },
  },
}
</script>
